import { render, staticRenderFns } from "./CartHeader.vue?vue&type=template&id=2a5decda&scoped=true"
import script from "./CartHeader.vue?vue&type=script&lang=js"
export * from "./CartHeader.vue?vue&type=script&lang=js"
import style0 from "./CartHeader.vue?vue&type=style&index=0&id=2a5decda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5decda",
  null
  
)

export default component.exports